import React from "react";
import { Accordion, AccordionSummary, AccordionDetails, Box, Button, CircularProgress, Typography } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useTranslation } from "react-i18next";
import GasCylinderForm from "./Form";
import { SETTING_TABLE_NAME } from "./../../../constants/settingsTableName";
import { useMsal } from "Auth/msal-context";
import { useKeyboard } from "../../../hooks/KeyboardContext";
import useSettings from "../../../hooks/useSettings";

const transformResponse = (res) => res.jsonData;

const GasCylinderSettings = () => {
  const { t } = useTranslation("common");
  const { isAuthorized, isEdge } = useMsal();
  const { registerInput } = useKeyboard();

  const { formState, setFormState, loading, error, fetchSettings, saveSettings } =
    useSettings(SETTING_TABLE_NAME.GAS_CYLINDER_SETTINGS, transformResponse);

  const onChangeHandler = (type, value, index, component) => {
    setFormState((prev) => {
      if (!prev) return prev;
      const arr = Object.values(prev);
      const updated = arr.map((data, idx) => {
        if (idx !== index) return data;
        if (type === "spanTarget" && component) {
          return {
            ...data,
            components: data.components.map((c) =>
              c.name === component ? { ...c, spanTarget: value } : c
            ),
          };
        }
        return { ...data, [type]: value };
      });
      return updated;
    });
  };

  const inputSelected = (e, name) => {
    const parts = name.split("|");
    registerInput(name, e.target.value, (v) => {
      if (parts[0] === "spanTarget" && parts.length === 3) {
        onChangeHandler("spanTarget", v, parseInt(parts[1]), parts[2]);
      } else {
        onChangeHandler(parts[0], v, parseInt(parts[1]));
      }
    });
  };

  const handleSave = () => {
    if (!formState) return;
    const payload = Object.values(formState);
    saveSettings(payload);
  };

  return (
    <Accordion sx={{ mb: 2 }} disableGutters onChange={(e, expanded) => { if (expanded) fetchSettings(); }}>
      <AccordionSummary expandIcon={<ExpandMoreIcon />} sx={{ bgcolor: "primary.main", color: "common.white" }}>
        <Typography sx={{ fontWeight: "bold", fontSize: "1.5rem" }}>Gas Cylinders</Typography>
      </AccordionSummary>
      <AccordionDetails sx={{ bgcolor: "background.light", p: 2 }}>
        {loading && <CircularProgress size={24} />}
        {error && (
          <Typography sx={{ textAlign: "center", color: "secondary.main" }}>
            {t("No Settings Found")}
          </Typography>
        )}
        {!loading && formState && (
          <GasCylinderForm
            formState={formState}
            onChangeHandler={onChangeHandler}
            inputSelected={inputSelected}
          />
        )}
        {(isAuthorized || isEdge) && formState && (
          <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 2 }}>
            <Button variant="contained" size="small" onClick={handleSave}>{t("Save")}</Button>
          </Box>
        )}
      </AccordionDetails>
    </Accordion>
  );
};

export default GasCylinderSettings;
